module.exports = __webpack_public_path__ + "img/h5_rw01@3x.acac951a.png";